interface RowInformationProps {
  label: string;
  value: string | number | React.ReactNode;
  labelIcon?: React.ReactNode;
  className?: string;
}
export function RowInformation({
  label,
  value,
  labelIcon,
  className,
}: RowInformationProps) {
  return (
    <div
      className={`flex gap-8 items-center p-1 border-b  justify-between ${
        className || ""
      }`}
    >
      <label className="ui-form-label flex gap-2 items-center mb-1">
        {labelIcon}
        {label}
      </label>
      <div className="text-xs font-semibold">{value}</div>
    </div>
  );
}
